<template>
  <div class="auth-wrapper email-unverified">

    <div v-if="!isMobile" class="auth-wrapper auth-wrapper-left"></div>

        <div class="auth-wrapper-rigth">
            <div class="auth-wrapper__content">
             <div class="auth-wrapper__logo logo">
                    <figure class="figure-logo">
                        <img src="/static/logos/logo_dv7.png" alt="40%" width="80%">
                    </figure>
                </div>

            <p>
              {{$t('auth.emailUnverified.pleaseConfirmYourEmailAt')}}
              <strong>{{ email }}</strong>  
              {{$t('auth.emailUnverified.toContinue')}}
            </p>
            <el-button
              type="primary"
              style="width:100%;"
              @click="sendEmailVerification"
              :disabled="sent"
            >{{$t('auth.emailUnverified.resendEmailConfirmation')}}</el-button>
            <p class="text-center">
              <a href="javascript:" @click="signout">{{$t('auth.emailUnverified.signInWithAnotherAccount')}}</a>
            </p>
          </div>
        </div>
   
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app-email-unverified",

  data() {
    return {
      sent: false
    };
  },

  computed: {
    ...mapGetters({
      email: "auth/email",
      isMobile: "shared/isMobile"
    })
  },

  methods: {
    sendEmailVerification() {
      this.sent = true;
      this.$store.dispatch("auth/sendEmailVerification").catch(() => {
        this.sent = false;
      });
    },

    signout() {
      return this.$store.dispatch("auth/signout");
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/auth/email-unverified/email-unverified.vue?6d3d4ab8